export const INS_SUPER_ADMIN_BASEPATH = '/admin';
export const LEVEL_ONE_ADMIN_BASEPATH = '/level-one';
export const LEVEL_TWO_ADMIN_BASEPATH = '/level-two';
export const BRANCH_ADMIN_BASEPATH = '/level-three';
export const WHITE_BOARD = '/Educator/white/board';
export const NON_USER_SESSION = "/video";
const ID = '/:id';
const STUDENTID = '/:userId';
const TUTORID = '/:userId';
const SUBJECTID = '/:subjectId';
const SUBCATEGORYID = '/:subcategoryId';
const LEVELID = '/:levelId';
const VISITID = '/:visitId';
const EDUCATORID = '/:educatorUserId';

export const SUPER_ADMIN_ROUTES_SECONDARY_PATH = {
    SUPER_ADMIN: '/super_admin',
    DASHBOARD: '/dashboard',
    USERS: '/users',
    TUTOR_INFO: '/tutor/view',
};

export const INS_SUPER_ADMIN_ROUTES = {
    DASHBOARD: `${INS_SUPER_ADMIN_BASEPATH}${ID}/dashboard`,
    LEVEL_WISE_REPORT: `${INS_SUPER_ADMIN_BASEPATH}${ID}/dashboard/level-report`,
    VIEW_TOP_LEVEL: `${INS_SUPER_ADMIN_BASEPATH}${ID}/level-one${LEVELID}`,
    TOP_LEVELS: `${INS_SUPER_ADMIN_BASEPATH}${ID}/level-one`,
    SECOND_LEVELS: `${INS_SUPER_ADMIN_BASEPATH}${ID}/level-two`,
    SCHOOL_ADMINS: `${INS_SUPER_ADMIN_BASEPATH}${ID}/level-three`,
    ADD_TOP_LEVEL: `${INS_SUPER_ADMIN_BASEPATH}${ID}/level-one-add`,
    EDIT_TOP_LEVEL: `${INS_SUPER_ADMIN_BASEPATH}${ID}/level-one${LEVELID}/edit`,
    STUDENTS: `${INS_SUPER_ADMIN_BASEPATH}${ID}/students`,
    TUTORS: `${INS_SUPER_ADMIN_BASEPATH}${ID}/educators`,
    CHANGE_PASSWORD: `${INS_SUPER_ADMIN_BASEPATH}/change-password${ID}`,
    FINANCIAL_REPORT: `${INS_SUPER_ADMIN_BASEPATH}${ID}/financial-reports`,
    CUSTOM_FINANCIAL_REPORT: `${INS_SUPER_ADMIN_BASEPATH}${ID}/financial-reports/custom-report${EDUCATORID}`,
    PAYOUT_REPORT: `${INS_SUPER_ADMIN_BASEPATH}${ID}/financial-reports/payout-report${EDUCATORID}`,
};

export const INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH = {
    INS_SUPER_ADMIN: '/admin',
    DASHBOARD: '/dashboard',
    TOP_LEVELS: '/level-one',
    SECOND_LEVELS: '/level-two',
    SCHOOL_ADMIN: '/level-three',
    STUDENTS: '/students',
    TUTORS: '/educators',
    ADD_TOP_LEVEL: '/level-one-add',
    EDIT: '/edit',
    CHANGE_PASSWORD: '/change-password',
};

export const BRANCH_ADMIN_ROUTES = {
    DASHBOARD: `${BRANCH_ADMIN_BASEPATH}${ID}/dashboard`,
    LEVEL_WISE_REPORT: `${BRANCH_ADMIN_BASEPATH}${ID}/dashboard/level-report`,
    CHANGE_PASSWORD: `${BRANCH_ADMIN_BASEPATH}/change-password${ID}`,
    STUDENTLIST: `${BRANCH_ADMIN_BASEPATH}${ID}/students`,
    TUTORLIST: `${BRANCH_ADMIN_BASEPATH}${ID}/educators`,
    SUBJECTLIST: `${BRANCH_ADMIN_BASEPATH}${ID}/subjects`,
    SUB_CATEGORY_LIST: `${BRANCH_ADMIN_BASEPATH}${ID}/sub-categories`,
    SESSIONS_LIST: `${BRANCH_ADMIN_BASEPATH}${ID}/sessions`,
    CANCEL_REQUEST_LIST: `${BRANCH_ADMIN_BASEPATH}${ID}/cancel-request`,

    STUDENT: `${BRANCH_ADMIN_BASEPATH}${ID}/user${STUDENTID}/student`,
    TUTOR: `${BRANCH_ADMIN_BASEPATH}${ID}/user${TUTORID}/educator`,
    SUBJECT: `${BRANCH_ADMIN_BASEPATH}${ID}/subject${SUBJECTID}/view`,
    SUBCATEGORY: `${BRANCH_ADMIN_BASEPATH}${ID}/sub-category${SUBCATEGORYID}/view`,

    ADD_STUDENT: `${BRANCH_ADMIN_BASEPATH}${ID}/student/add`,
    ADD_TUTOR: `${BRANCH_ADMIN_BASEPATH}${ID}/educator/add`,
    ADD_SUBJECT: `${BRANCH_ADMIN_BASEPATH}${ID}/subject/add`,
    ADD_SUBCATEGORY: `${BRANCH_ADMIN_BASEPATH}${ID}/subcategory/add`,
    ADD_NOTES: `${BRANCH_ADMIN_BASEPATH}${ID}/student/notes`,
    CREATE_SESSION: `${BRANCH_ADMIN_BASEPATH}${ID}/sessions/create`,
    SESSION_SUMMARY: `${BRANCH_ADMIN_BASEPATH}${ID}/sessions/summary${VISITID}`,

    STUDENT_BATCH: `${BRANCH_ADMIN_BASEPATH}${ID}/student/batch`,
    TUTOR_BATCH: `${BRANCH_ADMIN_BASEPATH}${ID}/educator/batch`,

    EDITSTUDENT: `${BRANCH_ADMIN_BASEPATH}${ID}/user${STUDENTID}/edit`,
    EDITTUTOR: `${BRANCH_ADMIN_BASEPATH}${ID}/educator${TUTORID}/edit`,
    EDIT_SUBJECT: `${BRANCH_ADMIN_BASEPATH}${ID}/subject${SUBJECTID}/edit`,
    EDIT_SUBCATEGORY: `${BRANCH_ADMIN_BASEPATH}${ID}/sub-category${SUBCATEGORYID}/edit`,
    FINANCIAL_REPORT: `${BRANCH_ADMIN_BASEPATH}${ID}/financial-reports`,
    CUSTOM_FINANCIAL_REPORT: `${BRANCH_ADMIN_BASEPATH}${ID}/financial-reports/custom-report${EDUCATORID}`,
    PAYOUT_REPORT: `${BRANCH_ADMIN_BASEPATH}${ID}/financial-reports/payout-report${EDUCATORID}`,
};

export const BRANCH_ADMIN_ROUTES_SECONDARY_PATH = {
    BRANCH_ADMIN: '/level-three',
    DASHBOARD: '/dashboard',
    STUDENTS: '/students',
    TUTOR: '/educators',
    DETAILS: '/details',
    REVENUES: '/revenues',
    SESSIONS: '/sessions',
    SUBJECT: '/subjects',
    SUB_CATEGORY: '/sub-categories',
    CHANGE_PASSWORD: '/change-password',
    CANCEL_REQUEST: '/cancel-request',

    STUDENT: '/student',
    SUBJECTS: '/subject',
    SUBCATEGORY: '/sub-category',
    TUTORS: '/educator',

    ADD_STUDENT: '/student/add',
    ADD_TUTOR: '/educator/add',
    ADD_SUBJECT: '/subject/add',
    ADD_SUBCATEGORY: '/subcategory/add',
    CREATE_SESSION: '/sessions/create',
    SUMMARY: '/sessions/summary',
    ADD_NOTES: '/student/notes',

    STUDENT_BATCH: '/student/batch',
    TUTOR_BATCH: '/educator/batch',

    USER: '/user',
    EDIT: '/edit',
    VIEW: '/view',
};

export const BRANCH_ADMIN_COMMON_ROUTES = {
    LOGIN: `${BRANCH_ADMIN_BASEPATH}/`,
    RESETPASSWORD: `${BRANCH_ADMIN_BASEPATH}/password/reset`,
    SESSIONS: `${BRANCH_ADMIN_BASEPATH}/${ID}/sessions`,
};

export const LEVEL_ONE_ADMIN_ROUTES = {
    DASHBOARD: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/dashboard`,
    LEVEL_WISE_REPORT: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/dashboard/level-report`,
    CHANGE_PASSWORD: `${LEVEL_ONE_ADMIN_BASEPATH}/change-password${ID}`,
    LEVEL_TWO: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/level-two`,
    BRANCH_ADMIN: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/level-three`,
    STUDENTS: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/students`,
    EDUCATORS: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/educators`,
    ADD_LEVEL: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/level-two/add`,
    VIEW_LEVEL: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/level-two${LEVELID}/view`,
    EDIT_LEVEL: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/level-two${LEVELID}/edit`,
    FINANCIAL_REPORT: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/financial-reports`,
    CUSTOM_FINANCIAL_REPORT: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/financial-reports/custom-report${EDUCATORID}`,
    PAYOUT_REPORT: `${LEVEL_ONE_ADMIN_BASEPATH}${ID}/financial-reports/payout-report${EDUCATORID}`,
};

export const LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH = {
    CHANGE_PASSWORD: '/change-password',
    LEVEL_ONE_ADMIN: '/level-one',
    DASHBOARD: '/dashboard',
    LEVEL_TWO: '/level-two',
    SCHOOL_ADMIN: '/level-three',
    STUDENTS: '/students',
    EDUCATORS: '/educators',
    ADD_LEVEL_TWO: '/level-two/add',
    VIEW: '/view',
    EDIT: '/edit',
};

export const LEVEL_ONE_ADMIN_COMMON_ROUTES = {
    LOGIN: `${LEVEL_ONE_ADMIN_BASEPATH}/`,
    RESETPASSWORD: `${LEVEL_ONE_ADMIN_BASEPATH}/password/reset`,
};

export const LEVEL_TWO_ADMIN_ROUTES = {
    DASHBOARD: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/dashboard`,
    LEVEL_WISE_REPORT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/dashboard/level-report`,
    CHANGE_PASSWORD: `${LEVEL_TWO_ADMIN_BASEPATH}/change-password${ID}`,
    LEVEL_THREE: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/level-three`,
    EDUCATORS: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/educators`,
    STUDENTS: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/students`,
    SUBJECTLIST: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/subjects`,
    SUB_CATEGORY_LIST: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/sub-categories`,

    ADD_LEVEL: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/level-three/add`,
    ADD_EDUCATOR: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/educator/add`,
    ADD_SUBJECT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/subject/add`,
    ADD_SUBCATEGORY: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/subcategory/add`,

    EDIT_LEVEL: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/level-three${LEVELID}/edit`,
    EDIT_EDUCATOR: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/educator${TUTORID}/edit`,
    EDIT_SUBJECT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/subject${SUBJECTID}/edit`,
    EDIT_SUBCATEGORY: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/sub-category${SUBCATEGORYID}/edit`,

    VIEW_LEVEL: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/level-three${LEVELID}/view`,
    VIEW_EDUCATOR: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/educator${TUTORID}/view`,
    SUBJECT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/subject${SUBJECTID}/view`,
    SUBCATEGORY: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/sub-category${SUBCATEGORYID}/view`,

    EDUCATOR_BATCH: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/educator/batch`,
    SESSIONS_LIST: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/sessions`,
    SESSION_SUMMARY: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/sessions/summary${VISITID}`,
    FINANCIAL_REPORT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/financial-reports`,
    CUSTOM_FINANCIAL_REPORT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/financial-reports/custom-report${EDUCATORID}`,
    PAYOUT_REPORT: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/financial-reports/payout-report${EDUCATORID}`,
    CREATE_SESSION: `${LEVEL_TWO_ADMIN_BASEPATH}${ID}/sessions/create`,
};

export const LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH = {
    CHANGE_PASSWORD: '/change-password',
    LEVEL_TWO_ADMIN: '/level-two',
    DASHBOARD: '/dashboard',
    LEVEL_THREE: '/level-three',
    EDUCATORS: '/educator',
    USER: '/user',
    STUDENTS: '/students',
    SESSION: '/sessions',
    ADD_LEVEL_THREE: '/level-three/add',
    ADD_EDUCATOR: '/educator/add',
    ADD_SUBJECT: '/subject/add',
    ADD_SUBCATEGORY: '/subcategory/add',

    EDIT: '/edit',
    VIEW: '/view',

    SUBJECT: '/subject',
    SUBJECTS: '/subjects',
    SUBCATEGORY: '/sub-category',
    SUB_CATEGORY: '/sub-categories',
    SUMMARY: '/sessions/summary',
    EDUCATOR_BATCH: '/educator/batch',
    CREATE_SESSION: '/sessions/create',
};

export const LEVEL_TWO_ADMIN_COMMON_ROUTES = {
    LOGIN: `${LEVEL_TWO_ADMIN_BASEPATH}/`,
    RESETPASSWORD: `${LEVEL_TWO_ADMIN_BASEPATH}/password/reset`,
};
